import React from 'react';
import './RateOption.scss';

/** @import {RateOptionProps} from './RateOptionTypes' */

function RateOption(/** @type {RateOptionProps} */ { name, rate, oldrate }) {
    return (
        <div className="rateOption">
            <h3 className="optionTitle">{name}</h3>
            <div className="rateWrapper">
                <span className="rate">{Number(oldrate).toFixed(2)}%</span>
                <span className="rateType">AER*/gross</span>
            </div>
            <div className="pb_divider" />
            <p className="newCustomerRate">
                New customer rate: <strong>{Number(rate).toFixed(2)}% AER*/gross</strong>
            </p>
            <div className="pb_s_divider" />
        </div>

        //        <div className="rateOption">
        //    <h3 className="optionTitle">{name}</h3>
        //    <div className="rateWrapper">
        //        <span className="rate">{rate}</span>
        //        <span className="rateType">AER/gross*</span>
        //    </div>
        //    <div className="pb_divider" />
        //    <p className="newCustomerRate">
        //        New customer rate: <strong>{rate} AER</strong>*
        //    </p>
        //</div>
    );
}

export default RateOption;